import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/shared/services/auth-service/auth.service";
import { DashboardService } from "src/app/shared/services/dashboard/dashboard.service";
import { MessagingService } from "src/app/shared/services/messaging/messaging.service";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
})
export class DashboardComponent implements OnInit {
  // Subscription
  // super admin
  SAbarCountSubscription: Subscription;
  SApageAnalyserSubscription: Subscription;
  SArevenueSummarySubscription: Subscription;

  //service provider admin
  SPAbarCountSubscription: Subscription;

  //advertiser login
  AdvertiserCountSubscription: Subscription;

  // super admin
  countryNameFilter: any = "Jordan";
  bgColors = ["#FF0000", "#FFE5E5", "#FFCDCD", "#FF8F8F"];
  // sendData = [20, 30, 40, 10];
  // sendlabels = ['Services', 'Featured', 'Company page', 'Advertisement']
  sendData: any = [];
  sendlabels: any = [];

  lineChartLabelsip: any;
  lineChartData: any = [
    // {
    //   label: 'ACTIVE',
    //   borderColor: '#42f5ec',
    //   backgroundColor: '#42f5ec',
    //   lineTension: 0,
    //   fill: false,
    //   data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    // },
    // {
    //   label: 'EXPIRED',
    //   borderColor: '#f54254',
    //   lineTension: 0,
    //   backgroundColor: '#f54254',
    //   fill: false,
    //   data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    // },
    // {
    //   label: 'APPROVED',
    //   borderColor: '#f59642',
    //   lineTension: 0,
    //   backgroundColor: '#f59642',
    //   fill: false,
    //   data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    // },
    // {
    //   label: 'INPROGRESS',
    //   borderColor: '#f542ef',
    //   backgroundColor: '#f542ef',
    //   lineTension: 0,
    //   fill: false,
    //   data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    // }
  ];
  // page analyser output
  pageAnalyserSuperAdmin = [];
  pageAnalyserSpa: [] = [];
  // bar chart
  labelsBarChart: [];
  // labelsBarChart = ["2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021"]
  datasetBarChart = [
    {
      label: "Users",
      backgroundColor: "#7C86AA",
      data: [1, 27, 34, 12, 20, 32, 36, 59],
    },
    {
      label: "Advertisers",
      backgroundColor: "#EB5757",

      data: [44, 23, 35, 42, 20, 32, 46, 29],
    },
    {
      label: "Services",
      backgroundColor: "#BB6BD9",
      data: [337, 23, 64, 30, 33, 32, 36, 29],
    },
    {
      label: "Service providers",
      backgroundColor: "#F2994A",
      data: [67, 52, 56, 59, 63, 42, 36, 39],
    },
  ];
  // SPA
  // polar
  bgColorsPolar = ["#0263FF", "#FF7723", "#8E30FF", "#BC60E5", "#8B1573"];
  // sendDataPolar = [50, 45, 40, 30, 35];
  // sendlabelsPolar = ['Assigned', 'Quotation sent', 'Communicating', 'Payment pending', 'User declined'];
  sendDataPolar: [];
  sendlabelsPolar: [];
  // bar chart
  SPAlabelsBarChart: [];
  SPAdatasetBarChart = [
    {
      data: [],
      backgroundColor: ["#0263FF", "#FF7723", "#8E30FF", "#8CBB3B"],
      borderWidth: 0,
      barPercentage: 0.2,
      scaleSteps: 30,
    },
  ];
  //Advertiser
  // polar
  AdbgColorsPolar = ["#0263FF", "#FF7723", "#8E30FF", "#BC60E5", "#8B1573"];
  AdsendDataPolar = [50, 45, 40, 30, 35];
  AdsendlabelsPolar = [
    "Homepage",
    "Cleaning",
    "Plumbing",
    "Electrical",
    "Electronics",
  ];
  // bar chart

  AdSPAlabelsBarChart: any;
  AdSPAdatasetBarChart = [
    {
      data: [],
      backgroundColor: [],
      borderWidth: 0,
      barPercentage: 0.2,
      scaleSteps: 30,
    },
  ];
  // filters
  selectedCountry: any = "Country";
  // 7days, month, 6month, 5year

  filterValues: any = [];
  selectedFilterValue: any = this.filterValues[3];
  // users
  userInfo: any;
  role: any;
  currentToken: any;
  userDetails: any;
  accessModuleList: any;
  loggedInRole: any;
  countryDetails = {
    areaCodes: null,
    dialCode: "962",
    iso2: "jo",
    name: "Jordan (‫الأردن‬‎)",
    priority: 0,
  };

  initialCountryFlag = {
    initialCountry: "jo",
  };
  transactionData: [];
  constructor(
    private authService: AuthService,
    private dashboardService: DashboardService,
    private messagingService: MessagingService,
    private router: Router,
    private translateService: TranslateService,
  ) {
    this.userInfo = this.authService.getPersonData();
    const isToken = this.authService.getToken();
    this.messagingService.getPermission().subscribe(res => {
      console.log("=>(dashboard.component.ts:176) res", res);
      if(res === "denied" || res === "granted") {
        this.authService.setAlert(false);
      } else {
        this.authService.setAlert(true);
      }
    })
    this.dashboardService._getCountryDetails.subscribe((res: any) => {
      if (res?.name) {
        this.countryDetails = res;
      }
    });


  }

  ngOnInit(): void {
    this.filterValues = [
      {
        name: "7days",
        displayName: this.translateService.instant("page.lastsevendays"),
      },
      {
        name: "month",
        displayName: this.translateService.instant("page.lastonemonth"),
      },
      {
        name: "6month",
        displayName: this.translateService.instant("page.lastsixmonths"),
      },
      {
        name: "5year",
        displayName: this.translateService.instant("page.lastfiveyears"),
      },
    ];
    this.datasetBarChart = [
      {
        label: this.translateService.instant("page.users"),
        backgroundColor: "#7C86AA",
        data: [1, 27, 34, 12, 20, 32, 36, 59],
      },
      {
        label: this.translateService.instant("page.advertisers"),
        backgroundColor: "#EB5757",

        data: [44, 23, 35, 42, 20, 32, 46, 29],
      },
      {
        label: this.translateService.instant("page.services"),
        backgroundColor: "#BB6BD9",
        data: [337, 23, 64, 30, 33, 32, 36, 29],
      },
      {
        label: this.translateService.instant("page.serviceproviders"),
        backgroundColor: "#F2994A",
        data: [67, 52, 56, 59, 63, 42, 36, 39],
      },
    ];
    this.selectedFilterValue = this.filterValues[3];

    this.translateService.onLangChange.subscribe((resp) => {
      this.filterValues = [
        {
          name: "7days",
          displayName: this.translateService.instant("page.lastsevendays"),
        },
        {
          name: "month",
          displayName: this.translateService.instant("page.lastonemonth"),
        },
        {
          name: "6month",
          displayName: this.translateService.instant("page.lastsixmonths"),
        },
        {
          name: "5year",
          displayName: this.translateService.instant("page.lastfiveyears"),
        },
      ];
      this.datasetBarChart = [
        {
          label: this.translateService.instant("page.users"),
          backgroundColor: "#7C86AA",
          data: [1, 27, 34, 12, 20, 32, 36, 59],
        },
        {
          label: this.translateService.instant("page.advertisers"),
          backgroundColor: "#EB5757",

          data: [44, 23, 35, 42, 20, 32, 46, 29],
        },
        {
          label: this.translateService.instant("page.services"),
          backgroundColor: "#BB6BD9",
          data: [337, 23, 64, 30, 33, 32, 36, 29],
        },
        {
          label: this.translateService.instant("page.serviceproviders"),
          backgroundColor: "#F2994A",
          data: [67, 52, 56, 59, 63, 42, 36, 39],
        },
      ];
      this.selectedFilterValue = {
        ...this.filterValues[3],
        displayName: this.translateService.instant("page.lastfiveyears"),
      };
    });

    const isToken = this.authService.getToken();
    this.userDetails = this.authService.getPersonData();
    this.accessModuleList = this.authService.getAccessModule();
    console.log("accessModuleList", this.accessModuleList);
    if (this.accessModuleList) {
      const isDashboard = this.accessModuleList.some(
        (ele) => ele.path === "dashboard"
      );
      console.log("isDashboard:", isDashboard);
      if (!isDashboard) {
        const routeTo = this.accessModuleList[0].path;
        this.router.navigate([`/${routeTo}`]);
      }
    }
    this.loggedInRole = this.authService.getPersonId();
    // this.selectedFilterValue = this.filterValues[3];
    if (this.loggedInRole == 4) {
      const routeTo = this.accessModuleList[0].path
        ? this.accessModuleList[0].path
        : "dashboard";
      this.router.navigate([`/${routeTo}`]);
    }
    if (isToken) {
      if (this.currentToken) {
        this.addDeviceDetails();
      }
    }
    this.role = this.authService.getPersonId();
    this.getAdvertiserPaymentGraph(this.userDetails._id);
    if (this.role === "1" || this.role === "4") {
      this.getSuperAdminBarCount();
      this.pageAnalyser();
      this.revenueSummary();
      this.getTransactionSummary();
    }
    if (this.role === "2" || this.role === "5") {
      this.getSPAbarCount();
      this.getSPAPolarGraph();
      this.spaPageAnalyser();
    }

    // advertiser dashboard
    if (this.role === "3") {
      this.getAdvertiserPolarGraph();
    }

    this.onCountryChange(this.countryDetails);
  }
  addDeviceDetails() {
    const jwtToken = this.authService.getToken();
    const userDetails = this.authService.getPersonData();
    const payload = {
      language: "English",
      device: "",
      userType: "superadmin",
      accessToken: jwtToken,
      fcmTokenKey: this.currentToken,
      lastLoginDate: Date.now(),
      countryId: "610a795f460faaed8387d981",
      timezone: "",
      utcOffset: "",
      userId: userDetails.data._id,
    };
    this.authService.addDeviceDetails(payload).subscribe((res) => {});
  }
  spaPageAnalyser() {
    const payload = {
      userId: this.userInfo.data._id,
      roleName: "spa", //required
      country: this.countryNameFilter, // india
      filtertype: this.selectedFilterValue.name, //  7days, month, 6month, year
    };
    this.SApageAnalyserSubscription = this.dashboardService
      .spaPageAnalyser(payload)
      .subscribe((res: any) => {
        this.pageAnalyserSpa = res.data;
      });
  }
  // Super admin
  getSuperAdminBarCount() {
    const payload = {
      filtertype: this.selectedFilterValue.name,
      country: this.countryNameFilter,
    };
    this.SAbarCountSubscription = this.dashboardService
      .getSABarCount(payload)
      .subscribe(
        (res: any) => {
          const { users, advertiser, service, spa, labelWithFormat } = res.data;

          if (res) {
            this.datasetBarChart[0].data = users;
            this.datasetBarChart[1].data = advertiser;
            this.datasetBarChart[2].data = service;
            this.datasetBarChart[3].data = spa;
            this.labelsBarChart = labelWithFormat;
            this.dashboardService.setSAbarData(
              this.datasetBarChart,
              this.labelsBarChart
            );
          } else {
          }
        },
        (err) => {
          this.datasetBarChart[0].data = [];
          this.datasetBarChart[1].data = [];
          this.datasetBarChart[2].data = [];
          this.datasetBarChart[3].data = [];
          this.labelsBarChart = [];
          this.dashboardService.setSAbarData(
            this.datasetBarChart,
            this.labelsBarChart
          );
        }
      );
  }
  pageAnalyser() {
    const payload = {
      roleName: "superadmin", //required
      country: this.countryNameFilter ? this.countryNameFilter : "", // india
      filtertype: this.selectedFilterValue.name, //  7days, month, 6month, year
    };
    this.SApageAnalyserSubscription = this.dashboardService
      .pageAnalyser(payload)
      .subscribe((res: any) => {
        this.pageAnalyserSuperAdmin = res.data;
      });
  }
  revenueSummary() {
    const payload = {
      roleName: "superadmin", //required
      country: this.countryNameFilter, // india
      filtertype: this.selectedFilterValue.name, //  7days, month, 6month, year
    };
    this.SArevenueSummarySubscription = this.dashboardService
      .revenueSummary(payload)
      .subscribe(
        (res: any) => {
          if (res.success) {
            this.sendData = res.data.sendData;
            this.sendlabels = res.data.sendlabels;
            this.dashboardService.setSARevenueSummaryData(
              this.sendData,
              this.sendlabels
            );
          } else {
            this.sendData = [];
            this.sendlabels = [];
            this.dashboardService.setSARevenueSummaryData(
              this.sendData,
              this.sendlabels
            );
          }
        },
        (err) => {
          this.sendData = [];
          this.sendlabels = [];
          this.dashboardService.setSARevenueSummaryData(
            this.sendData,
            this.sendlabels
          );
        }
      );
  }
  // Advertisement
  getAdvertisement() {
    const payload = {
      roleName: "superadmin", //required
      country: this.countryNameFilter, // india or India
      filtertype: "12months", //  week, month, 3months, 6months, 12months
      categoryId: "", //
    };
    this.SArevenueSummarySubscription = this.dashboardService
      .advertisements(payload)
      .subscribe(
        (res: any) => {
          if (res.success) {
            this.sendData = res.data;
            this.sendlabels = res.data.sendlabels;
            this.dashboardService.setSAAdvertisementData(this.sendData);

            this.lineChartData[0].data = res?.data?.activeAdvertisementCount;
            this.lineChartData[1].data = res?.data?.expiredAdvertisementCount;
            this.lineChartData[2].data = res?.data?.approvedAdvertisementCount;
            this.lineChartData[0].data = res?.data?.requestedAdvertisementCount;

            this.lineChartLabelsip = res?.data?.labelWithFormat;
          } else {
            this.sendData = [];
            this.sendlabels = [];
            this.dashboardService.setSAAdvertisementData(this.sendData);
          }
        },
        (err) => {
          this.sendData = [];
          this.sendlabels = [];
          this.dashboardService.setSAAdvertisementData(this.sendData);
        }
      );
  }
  // SPA
  getSPAbarCount() {
    const payload = {
      userId: this.userInfo.data._id,
      filtertype: this.selectedFilterValue.name,
      country: this.countryNameFilter,
    };
    this.SPAbarCountSubscription = this.dashboardService
      .getSPABarCount(payload)
      .subscribe((res: any) => {
        this.SPAlabelsBarChart = res.label;
        this.SPAdatasetBarChart[0].data = res.dataSet;
        this.dashboardService.setSPABarChartData(
          this.SPAdatasetBarChart,
          this.SPAlabelsBarChart
        );
      });
  }
  getSPAPolarGraph() {
    const payload = {
      userId: this.userInfo.data._id,
      filtertype: this.selectedFilterValue.name,
      country: this.countryNameFilter,
    };
    this.SPAbarCountSubscription = this.dashboardService
      .getSPAPolarGraphCount(payload)
      .subscribe((res: any) => {
        this.sendDataPolar = res.dataSet;
        this.sendlabelsPolar = res.label;
        this.dashboardService.setSPAPolarChartData(
          this.sendDataPolar,
          this.sendlabelsPolar
        );
      });
  }
  onFilterValueChange(item) {
    this.selectedFilterValue = item;
    if (this.role === "1") {
      this.getSuperAdminBarCount();
      this.pageAnalyser();
      this.revenueSummary();
      this.getTransactionSummary();
    }
    if (this.role === "2") {
      this.getSPAbarCount();
      this.getSPAPolarGraph();
      this.spaPageAnalyser();
    }
    if (this.role === "3") {
      this.getAdvertiserPolarGraph();
    }
  }
  hasError(event) {}
  telInputObject(event) {}
  onCountryChange(event) {
    this.selectedCountry = event.name;
    this.initialCountryFlag = {
      initialCountry: event?.iso2 ? event?.iso2 : "jo",
    };
    this.countryNameFilter = this.selectedCountry.split("(")[0].trim();
    this.dashboardService.setCountryDetails(event);
    if (this.role === "1") {
      this.getSuperAdminBarCount();
      this.pageAnalyser();
      this.revenueSummary();
      this.getTransactionSummary();
    }
    if (this.role === "2") {
      this.getSPAbarCount();
      this.getSPAPolarGraph();
      this.spaPageAnalyser();
    }
    if (this.role === "3") {
      this.getAdvertiserPolarGraph();
    }
  }

  getAdvertiserPolarGraph() {
    const payload = {
      roleName: "advertiser",
      userId: this.userInfo.data._id,
      filtertype: this.selectedFilterValue.name, //  7days, month, 6month, year,
      country: this.countryNameFilter,
    };
    this.AdvertiserCountSubscription = this.dashboardService
      .getAdvertiserPolarGraphCount(payload)
      .subscribe((res: any) => {
        if (res && res.success) {
          this.AdbgColorsPolar = res?.data?.sendColors;
          this.AdsendDataPolar = res?.data?.sendData;
          this.AdsendlabelsPolar = res?.data?.sendLabels;
          this.dashboardService.setAdvertiserPolarGraphData(
            this.AdsendDataPolar,
            this.AdsendlabelsPolar,
            this.AdbgColorsPolar
          );
        } else {
          this.AdbgColorsPolar = res?.data?.sendColors;
          this.AdsendDataPolar = res?.data?.sendData;
          this.AdsendlabelsPolar = res?.data?.sendLabels;
          this.dashboardService.setAdvertiserPolarGraphData(
            this.AdsendDataPolar,
            this.AdsendlabelsPolar,
            this.AdbgColorsPolar
          );
        }
      });
  }
  getAdvertiserPaymentGraph(id) {
    this.dashboardService
      .getAdvertiserPaymentGraph({})
      .subscribe((res: any) => {
        this.AdSPAlabelsBarChart = res.data.title;
        this.AdSPAdatasetBarChart[0].data = res.data.value;
        this.AdSPAdatasetBarChart[0].backgroundColor = res.data.color;
        this.dashboardService.setAdvertiserPaymentGraphData(
          this.AdSPAdatasetBarChart,
          this.AdSPAlabelsBarChart
        );
      });
  }
  getTransactionSummary() {
    const payload = {
      filtertype: this.selectedFilterValue.name, //  7days, month, 6month, year,
      country: this.countryNameFilter,
    };
    this.dashboardService.transactionSummary(payload).subscribe((res: any) => {
      this.transactionData = res.data;
    });
  }
}
